import { registerKnockoutBinding } from "flow/knockout/register";
import { setupPdfViewer } from "flow/wrappers/setupPdfViewer";

registerKnockoutBinding("pdfviewer", {
    init(element: any, valueAccessor: () => any) {
        const value = valueAccessor();

        setupPdfViewer(element, value);
    }
});
